
import { ValidUnitValue } from '@/types/unit-types';

// Helper function to convert unit strings to valid enum values
export const convertUnitToEnum = (unit: string): ValidUnitValue => {
  const unitMapping: { [key: string]: ValidUnitValue } = {
    'hour': 'hr',
    'hours': 'hr', 
    'day': 'day',
    'days': 'day',
    'item': 'item',
    'items': 'item',
    'square_meter': 'm²',
    'square_meters': 'm²',
    'm2': 'm²',
    'sqm': 'm²',
    'cubic_meter': 'm³',
    'cubic_meters': 'm³',
    'm3': 'm³',
    'cbm': 'm³',
    'box': 'box',
    'boxes': 'box',
    'each': 'each',
    'linear_meter': 'linear_m',
    'linear_meters': 'linear_m',
    'linear_m': 'linear_m',
    'lm': 'linear_m',
    'kilogram': 'kg',
    'kilograms': 'kg',
    'kg': 'kg',
    'liter': 'l',
    'liters': 'l',
    'litre': 'l',
    'litres': 'l',
    'l': 'l'
  };
  const mapped = unitMapping[unit.toLowerCase()];
  if (mapped) return mapped;
  return 'item';
};
